import { createContext } from "react";
import type { ModalConfig } from "../utils/types";

export interface ModalContextType {
  openModal: (config: ModalConfig) => void;
  closeModal: () => void;
  isModalOpen: boolean;
}

export const ModalContext = createContext<ModalContextType>({
  openModal: () => {},
  closeModal: () => {},
  isModalOpen: false,
});

